// Screen 8 (spec 13 §Screens): the import wizard at `/c/{slug}/kpis/import` (KPIs › data
// entry: managers and operators). Time-entry and cost imports are `core`. M2-08:
// `?kind=tasks&board={id}` opens the Tasks kind with that board chosen (the board's "Import
// tasks" button).
import { createRoute } from "@tanstack/react-router";
import { ImportWizard } from "../features/import/import-wizard";
import { useCompany } from "../features/use-feature";
import { DataEntryGate } from "../shell/mode-gate";
import { kpisRoute } from "./c.$slug.kpis";

const ID = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;

export const importRoute = createRoute({
  getParentRoute: () => kpisRoute,
  path: "import",
  validateSearch: (search: Record<string, unknown>): { kind?: "tasks"; board?: string } => ({
    ...(search.kind === "tasks" ? { kind: "tasks" as const } : {}),
    ...(typeof search.board === "string" && ID.test(search.board) ? { board: search.board } : {}),
  }),
  component: function Import() {
    const { api } = importRoute.useRouteContext();
    const { kind, board } = importRoute.useSearch();
    return (
      <DataEntryGate what="CSV import">
        <ImportWizard
          api={api}
          company={useCompany()}
          {...(kind ? { initialKind: kind } : {})}
          {...(board ? { initialBoard: board } : {})}
        />
      </DataEntryGate>
    );
  },
});
